import i21 from '../../img/pizza/21.jpg'
import i22 from '../../img/pizza/22.jpg'
import i23 from '../../img/pizza/23.jpg'
import i24 from '../../img/pizza/24.jpg'
import i25 from '../../img/pizza/25.jpg'
import i26 from '../../img/pizza/26.jpg'

export const pizza=[
    {
        "id" : 21 ,
        "title" : "پیتزا رست بیف",
        "price":"300",
        "desciption":"خمیر پیتزا 21*21 پنجره ای ، رست بیف ، سس آلفردو ، قارچ ، زیتون سیاه و پنیر موزارلا",
        "image" : i21
    },
    {
        "id" : 22 ,
        "title" : "پیتزا مخصوص",
        "price":"270",
        "desciption":"خمیر پیتزا 21*21 پنجره ای ، ژامبون گوشت و مرغ ، هات داگ ، گوشت چرخکرده ، قارچ ، زیتون سیاه ، فلفل دلمه ای و پنیر موزارلا",
        "image" : i22
    },
    {
        "id" : 23 ,
        "title" : "پیتزا پپرونی",
        "price":"220",
        "desciption":"خمیر پیتزا 21*21 پنجره ای ، پپرونی ، سس تند ، پنیر موزارلا و فلفل هالوپینو",
        "image" : i23
    },
    {
        "id" : 24 ,
        "title" : "پیتزا دونر استیک",
        "price":"270",
        "desciption":"خمیر پیتزا 21*21 پنجره ای ، دونر استیک گوشت ، قارچ ، پنیر موزارلا ، سس آلفردو و زیتون سیاه ",
        "image" : i24
    },
    {
        "id" : 25 ,
        "title" : "پیتزا چیکن آلفردو ",
        "price":"240",
        "desciption":"خمیر پیتزا 21*21 پنجره ای ، استیک مرغ ، قارچ ، پنیر موزارلا ، سس آلفردو و فلفل دلمه ای        ",
        "image" : i25
    },
    {
        "id" : 26 ,
        "title" : "پیتزا مخلوط",
        "price":"210",
        "desciption":"خمیر پیتزا 21*21 ، هات داگ ، ژامبون گوشت و مرغ ، قارچ ، پنیر موزارلا ، فلفل دلمه ای و زیتون سیاه        ",
        "image" : i26
    },

    
  
]